'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis([].slice);



//////////////////
// WEBPACK FOOTER
// ./~/react-fileupload-progress/~/core-js/internals/array-slice.js
// module id = 600
// module chunks = 0